module.exports = __webpack_public_path__ + "img/61.29c1b00a.jpg";